import { getAllSupplyLocationIDEffect } from '@/redux/Savers/SaversEffects';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FormSelectBox from '../Inputs/FormSelectBox';

const SupplyLocationIDSelector = ({
  placeholder,
  label,
  rules = [],
  name,
  editMode,
  margin,
  disabled,
  onChange,
  defaultValue,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const { selectedCompany } = useSelector((state) => state.auth);

  useEffect(() => {
    getUserList();
  }, [selectedCompany]);

  const getUserList = async () => {
    try {
      setLoading(true);
      const { data } = await getAllSupplyLocationIDEffect();

      const options = data
        .filter((row) => row.branchKey !== -1)
        .map((row) => ({
          label: row.branchDesc,
          value: row.branchKey,
        }));
      setOptions(options);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      defaultValue={defaultValue}
      editMode={editMode}
      margin={margin}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default SupplyLocationIDSelector;
